module.exports = __webpack_public_path__ + "static/media/rupeesCallectionIcon.c7700209.svg";